import Client from "../client/FireBase"

const createTokenFirebase = (data) => {
  return Client.post(`api/device`, data)
}

const subscribeNoti = (data) => {
  return Client.post(`api/subcribe-noti`, data)
}

const unSubscribeNoti = (data) => {
  return Client.post(`api/un-subcribe-noti`, data)
}

const userRepository = {
  createTokenFirebase,
  subscribeNoti,
  unSubscribeNoti
}
export default userRepository
